<template>
  <div></div>
</template>
<script>
import Util from "@/util";
import APIResource from "@/mixins/APIResource";
import APIAttendance from "@/mixins/APIAttendance";
import Head from "./Headers";
export default {
  mixins: [APIResource, APIAttendance],
  data() {
    return {
      userTypes: Util.defaultUserTypes(),
      headers: [],
      info: {},
      search: "",
      firstname: "",
      lastname: "",
      procceed: false,
      searchList: [],
      signin: {
        holder_type: "staff",
        holder: {
          _id: "",
          mobile: "",
          company: {},
          last_name: "",
          first_name: "",
          visitor_type: "",
          lanyard_number: ""
        },
        option: {
          sign_out_reason: "",
          sign_in_reason: "",
          wwcc_card: 0,
          class_type: "",
          appointment_user: "",
          policies: [],
          parent_name: "",
          signature: "",
          wwcc_no: "",
          station: "Front Desk"
        }
      }
    };
  },
  watch: {
    signin: {
      handler: function(obj) {
        if (!obj.holder_type) {
          this.signin.holder_type = "staff";
        }
        this.searchList = [];
        this.processHeader();
      },
      deep: true
    },
    search: {
      handler: function(keyword) {
        this.searchUserFromKeyword(keyword);
      }
    },
    firstname: {
      handler: function(keyword) {
        this.searchUserFromKeyword(keyword, "");
      }
    },
    lastname: {
      handler: function(keyword) {
        this.searchUserFromKeyword("", keyword);
      }
    }
  },
  computed: {
    hasLanyardOption: function() {
      let probe1 = ["contractor", "visitor"].includes(this.signin.holder_type);
      let probe2 = this.permissions.includes("lanyard");
      return probe1 && probe2;
    },
    hasWWCCOption: function() {
      let probe1 = ["contractor", "visitor"].includes(this.signin.holder_type);
      let probe2 = this.permissions.includes("wwcc");
      return probe1 && probe2;
    }
  },
  methods: {
    submitSignIn: function() {
      this.markAttendance("signin");
    },
    submitSignOut: function() {
      this.markAttendance("signout");
    },
    showMessage: function(message) {
      this.$toast.error(message, "Error", {
        position: "topCenter"
      });
    },
    validateAttendance: function() {
      if (!this.signin.holder_type) {
        this.showMessage("Contact type is not defined.");
        return false;
      }
      if (
        ["staff", "student"].includes(this.signin.holder_type) &&
        !this.signin.holder._id
      ) {
        this.showMessage("Contact is not selected.");
        return false;
      }
      if (
        ["visitor", "contractor"].includes(this.signin.holder_type) &&
        this.signin.option.policies.length === 0
      ) {
        this.showMessage("Policies can not be ignored.");
        return false;
      }
      return true;
    },
    signProceed: function(item) {
      this.$refs.searchfields.firstname = item.first_name;
      this.$refs.searchfields.lastname = item.last_name;
      this.procceed = true;
      this.signin.holder = item;
      this.info = item;
    },
    clearSearch: function() {
      this.firstname = "";
      this.lastname = "";
      this.signin.holder = {};
      this.procceed = false;
      this.info = {};
      this.$refs.searchfields.firstname = "";
      this.$refs.searchfields.lastname = "";
    },
    processHeader: function() {
      if (this.signin.holder_type === "staff") {
        this.headers = Head.hstaff;
      } else if (this.signin.holder_type === "student") {
        this.headers = Head.hstudent;
      } else if (this.signin.holder_type === "visitor") {
        this.headers = Head.hvisitor;
      } else if (this.signin.holder_type === "contractor") {
        this.headers = Head.hcontractor;
      }
    },
    searchUserFromKeyword: async function(fname, lname) {
      let entity = this.signin.holder_type;
      this.processHeader();
      try {
        let res = await this.searchUser(entity, fname, lname);
        this.searchList = res;
      } catch (error) {
        this.$toast.error("Failed to search users.", "Error", {
          position: "topCenter"
        });
      }
    },
    resetSignIn: function() {
      this.signin = {
        holder_type: "staff",
        holder: {
          _id: "",
          mobile: "",
          company: {},
          last_name: "",
          first_name: "",
          visitor_type: "",
          lanyard_number: ""
        },
        option: {
          sign_out_reason: "",
          sign_in_reason: "",
          wwcc_card: 0,
          class_type: "",
          appointment_user: "",
          policies: [],
          parent_name: "",
          signature: "",
          wwcc_no: "",
          station: "Front Desk"
        }
      };
    },
    markAttendance: async function(type) {
      if (!this.validateAttendance()) {
        return;
      }

      let contact = this.signin.holder_type;
      try {
        await this.postAttendance(contact, type, this.signin);
        let message =
          type === "signin"
            ? "Successfully signed in."
            : "Successfully signed out.";
        this.$toast.success(message, "Success", {
          position: "topCenter"
        });
        this.resetSignIn();
      } catch (error) {
        console.log(error);
        this.$toast.error(
          "Failed to mark attendance, Check the details before procceed.",
          "Error",
          {
            position: "topCenter"
          }
        );
      }
    }
  }
};
</script>
